import { Component, OnInit } from '@angular/core';
import { ContractSearchService } from '../Services/contract-search.service';
import { PolicyManualContent } from '../Models/common.model';

@Component({
  selector: 'policymanual-header',
  templateUrl: './policy-manual-header.component.html',
  styleUrls: []
})
export class PolicyManualHeaderComponent implements OnInit {

    searchContent = {} as PolicyManualContent;
    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
    }

    filterMetadata = { count: 0 };
    index = { count: 0 };

    constructor(public dataService: ContractSearchService) { }

    ngOnInit(): void {
        this.dataService.getPolicyManualContent().subscribe((data: PolicyManualContent) => {
            this.searchContent = data;
        })

        this.dataService.getCurrentPosition$.subscribe((position) => {
            this.index.count = position;
        });

        this.dataService.getTotalSearchCount$.subscribe((count) => {
            this.filterMetadata.count = count;
        });
    }

    onTextChange(text) {
        this.dataService.modifyString(text);
    }

    public findNext() {
        this.dataService.setPosition(1);
    }

    public findPrev() {
        this.dataService.setPosition(-1);
    }

}
